import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "blue",
  "use": "blue-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 14\" id=\"blue\"><defs><style>#blue .cls-1{fill:#e2e4ff;}#blue .cls-2{fill:#5890ff;}</style></defs><circle id=\"blue_椭圆形\" class=\"cls-1\" cx=\"7\" cy=\"7\" r=\"7\" /><circle id=\"blue_椭圆形-2\" data-name=\"椭圆形\" class=\"cls-2\" cx=\"7\" cy=\"7\" r=\"4\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol